const quotationChat = {
  quotationChatNavLabel: "צאת הצעת מחיר", // translated 
  quotationChatApprovalTitle: "צאת הצעת מחיר", // translated 
  quotationChatAccountNotApprovedTitle: "החשבון לא אושר", // translated 
  quotationChatAccountNotApprovedDescription:
    "החשבון שלך עדיין לא אושר. אנא פנה למנהל החשבון שלך למידע נוסף.", // translated 
  quotationChatViewAiChat: "צפה בצ'אט בינה מלאכותית", // translated 

  quotationRequestChatSessions: "הפעלות צאט", // translated 
  quotationRequestChatNoPastSessions: "אין העלות קודמות", // translated 
  quotationRequestChatNewChat: "צאת חדש", // translated 
  quotationRequestChatCloseSidebar: "סגור סרג'ל צד", // translated 
  quotationRequestChatSessionFallback: "הפעלת צאט", // translated 
  quotationRequestChatDefaultSessionName: "הפעלת צאת חדשה", // translated 
  quotationRequestChatTitle: "צ'אט בקשת הצעת מחיר", // translated 
  quotationRequestChatResponseLanguageLabel: "שפת תגובה", // translated 
  quotationRequestChatOpenSidebar: "פתח סרג'ל צד", // translated 
  quotationRequestChatRenameSession: "שנה שם הפעלת", // translated 
  quotationRequestChatDeleteSession: "מחק הפעל", // translated 
  quotationRequestChatToggleDarkMode: "החלף מצב כהה", // translated 
  quotationRequestChatSwitchToLightMode: "עליון למצבים בהיר", // translated 
  quotationRequestChatSwitchToDarkMode: "עליון למצבים כהה", // translated 
  quotationRequestChatEmptyStateHeading: "התחל שיחת בקשת הצעת מחיר חדשה", // translated 
  quotationRequestChatEmptyStateSubheading:
    "תאר את צרכי הנסיעה שלך ואני אקין עבורך בקשת הצעת מחיר.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "הקלד את ההודעה שלך כדי להתחיל שיחה... (Shift+Enter לשורה חדשה)", // translated 
  quotationRequestChatMessagePlaceholder: "הקלד את ההודעה שלך... (Shift+Enter לשורה חדשה)", // translated 
  quotationRequestChatUploadFile: "העלה קובץ", // translated 
  quotationRequestChatUploadAttachment: "העלה קובץ מצורף", // translated 

  quotationRequestChatStopGenerating: "הפסק יצירה", // translated 
  quotationRequestChatGenerateQuotation: "צור הצעת מחיר", // translated 
  quotationRequestChatGenerateFinalQuotation: "צור הצעת מחיר סופית", // translated 
  quotationRequestChatFinalizeQuotationRequest: "סיים בקשת הצעת מחיר", // translated 
  quotationRequestChatHoldToRecord: "החזק קלטת הודעה קולית", // translated 
  quotationRequestChatRecordingReleaseToSend: "מקליט, משחרר לשליחה", // translated 
  quotationRequestChatRecording: "מקליט...", // translated 
  quotationRequestChatSelectSessionFirst: "אנא בחר להפעיל צ'אט תחילה.", // translated 
  quotationRequestChatCancelVoiceRecording: "בטל הקלטה קולית", // translated 
  quotationRequestChatListening: "מאזין...", // translated 
  quotationRequestChatTranscribing: "מתמלל...", // translated 

  quotationRequestChatFileUploadedSuccess: "הקובץ הועלה בהצלחה.", // translated 
  quotationRequestChatUnsupportedFileType: "סוג קובץ שאינו נתמך. יש להעלות PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), טקסט/CSV או תמונה.", // translated
  quotationRequestChatFailedCreateSession: "יצירת הפעלת צ'אט נכשלה. נסה שוב.", // translated 
  quotationRequestChatFailedUploadFile: "העלאת הקובץ נכשלה. נסה שוב.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "אנא ענה על השאלות המתינות לפני שליחת הודעה נוספת.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "אנא ענה על השאלות המתינות לפני סיום בקשת הצעת המחיר.", // translated 
  quotationRequestChatFavoriteMarked: "הפעלת הצ'אט סומנה כמועדפת", // translated 
  quotationRequestChatFavoriteUnmarked: "הפעלת הצ'אט הושרה מהמועדפים", // translated 
  quotationRequestChatFailedSetFavorite: "סימון כמועדף נכשל", // translated 
  quotationRequestChatFailedUnsetFavorite: "הסרה מהמועדפים נכשלה", // translated 
  quotationRequestChatRenamedSuccess: "שם הפעלת הצ'אט שונה בהצלחה.", // translated 
  quotationRequestChatFailedRename: "שינוי שם הפעלת הצ'אט נכשל. נסה שוב.", // translated 
  quotationRequestChatDeletedSuccess: "הפעלת הצ'אט נמחקה בהצלחה.", // translated 
  quotationRequestChatFailedDelete: "מחיקת הפעלת הצ'אט נכשלה. נסה שוב.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "הקובץ המצורף נמחק בהצלחה.", // translated 
  quotationRequestChatFailedDeleteAttachment: "מחיקת הקובץ המצורף נכשלה. נסה שוב.", // translated 
  quotationRequestChatSubmittedSuccess:
    "בקשת הצעת מחיר נשלחה בהצלחה! הבקשה שלך בטיפול.", // translated 
  quotationRequestChatFailedSubmit: "שליחת בקשת הצעת מחיר נכשלה", // translated 
  quotationChatPdfDownloadedSuccess: "הורדת ה-PDF בהצלחה!", // translated 
  quotationChatFailedGeneratePdf: "יצירה PDF נכשלה", // translated 

  quotationRequestChatSubagentRequired:
    "אנא בחר משתמש תת-סוכן לפני שליחת בקשת הצעת המחיר.", // translated 
  quotationRequestChatAppUserLoading:
    "פרופיל משתמש ה-CRM שלך עדיין נטען. נסה שוב בעוד רגע.", // translated 
  quotationRequestChatAppUserMismatch:
    "פרופיל משתמש ה-CRM שלך אינו תואם להפעלת הצ'אט הזו.", // translated 

  quotationRequestChatRenameTitle: "שנה שם הפעלת צ'אט", // translated 
  quotationRequestChatSessionName: "שם הפעל", // translated 
  quotationRequestChatEnterSessionName: "הזן שם הפעל", // translated 
  quotationRequestChatSaving: "שומר...", // translated 
  quotationRequestChatSave: "שמור", // translated 
  quotationRequestChatDeleteTitle: "מחק הפעלת צאט", // translated 
  quotationRequestChatDeleteConfirm: "האם אתה בטוח שברצונך למחוק את הפעלת הצ'אט הזו?", // translated 
  quotationRequestChatDeleteCannotUndo: "לא ניתן לבטל פעולה זו.", // translated 
  quotationRequestChatDeleting: "מוחק...", // translated 
  quotationRequestChatDelete: "מחק", // translated 

  quotationRequestChatAttachmentsTitle: "קבצים מצורפים לצ'אט בקשת הצעת מחיר", // translated 
  quotationRequestChatLoadingAttachments: "טוען קבצים מצורפים...", // translated 
  quotationRequestChatNoAttachments: "לא נמצאו קבצים מצורפים", // translated 
  quotationRequestChatDeleteAttachment: "משק קובץ מצורף", // translated 
  quotationRequestChatUploadingAttachment: "מעלה קובץ מצורף...", // translated 
  quotationRequestChatUploadingAttachmentWait: "אנא המתן בזמן שהקובץ שלך מועלה.", // translated 

  quotationRequestChatAnswerPendingQuestions: "ענה על שאלות ממתינות", // translated 
  quotationRequestChatProposeOwnAnswer: "הצעת תשובה משלי", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "הקלד את התשובה שלך...", // translated 
  quotationRequestChatAnsweredOfTotal: '{{ענה}} מתוך {{סה"כ}} נענו', // translated 
  quotationRequestChatReadyToSubmit: "מוכן לשליחה", // translated 
  quotationRequestChatSubmitAll: "שלח הכל", // translated 
  quotationRequestChatRespondToOneQuestion: "ענה על {{count}} שאלה", // translated 
  quotationRequestChatRespondToManyQuestions: "ענה על {{count}} שאלות", // translated 

  quotationRequestChatFinalizeTitle: "סיים בקשת הצעת מחיר", // translated 
  quotationRequestChatLoadingSessionData: "טוען נתוני הפעלה...", // translated 
  quotationRequestChatErrorLoadingSession: "שגיאה בטעינת נתוני ההפעלה. נסה שוב.", // translated 
  quotationRequestChatQuotationTitle: "כותרת הצעת מחיר", // translated 
  quotationRequestChatExtraComments: "הערות נוספות", // translated 
  quotationRequestChatSubmitting: "שולה...", // translated 
  quotationRequestChatSubmit: "שלח", // translated 
  quotationRequestChatSubmittingOverlayTitle: "שלח בקשת הצעת מחיר...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "אנא המתן בזמן שבקשת הצעת המחיר שלך נשלחת.", // translated 

  quotationRequestChatSelectSubagent: "בכר תת-סוכה", // translated 
  quotationRequestChatSearchSubagents: "חפש תות-סוכרים...", // translated 
  quotationRequestChatLoadingSubagents: "טוען תת-סוכרים...", // translated 
  quotationRequestChatNoSubagentsFound: "לא נמצאו תת-סוכנים", // translated 
  quotationRequestChatNoSubagentsAvailable: "אין תת-סוכנים זמינים", // translated 
  quotationRequestChatSelectedSubagent: "נבחר: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "משתמשי תת-סוך", // translated 
  quotationRequestChatSearchUsers: "חפש משתמש...", // translated 
  quotationRequestChatNoUsersFound: "לא נמצאו משתמשים", // translated 
  quotationRequestChatNoUsersAvailable: "אין משתמשים זמינים", // translated 

  quotationChatDownloadSummaryTitle: "הורד את סיכום המחיר שלך", // translated 
  quotationChatDownloadSummaryDescription:
    "מלא את הפרטים שלך למטה כדי ליצור סיכום PDF מותאם אישית של המחיר לנסיעה. ה-PDF כולל את כל הנסיעה הפרטית, היעדים, מידע התחבורה ומסלול יום-יום.", // translated 
  quotationChatCustomerTitle: "תואר", // translated 
  quotationChatSelectTitle: "בחר תואר", // translated 
  quotationChatHonorificMr: "מר", // translated 
  quotationChatHonorificMrs: "גב'", // translated 
  quotationChatHonorificMs: "גב'", // translated 
  quotationChatHonorificDr: "ד\"ר",
  quotationChatHonorificProf: "פרוף'", // translated 
  quotationChatCustomerPhone: "טלפון", // translated 
  quotationChatCustomerCompany: "חברה", // translated 
  quotationChatCustomerMessage: "הודעה", // translated 
  quotationChatCustomerCountry: "מדינה", // translated 
  quotationChatGenerating: "יצרן...", // translated 
  quotationChatDownloadPdf: "הורדת PDF", // translated 

  quotationChatTripSummary: "סיכום נסיעה", // translated 
  quotationChatDownloadAsPdf: "הורדה כ-PDF", // translated 
  quotationChatNoTripSummary: "אין סיכום נסיעה זמין להפעלה זו.", // translated 

  quotationRequestChatThinking: "חושב...", // translated 
  quotationRequestChatSources: "מקורות", // translated 
  quotationRequestChatSearchingWebFor: 'מחפש באינטרנט: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "שירותים שבוצעו על ידי מפעיל הטיולים", // translated 
  quotationRequestChatServicesByCustomer: "שירותים שמטופלים על ידי הלקוח", // translated 
  quotationRequestChatReadyNotice:
    "אתה יכול ליצור הצעת מחיר לבקשה זו על ידי לחיצה על הכפתור מימין.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "צור הצעת מחיר סופית", // translated 

  quotationRequestChatMaybeYouWantToAsk: "אולי תרצה לשאול:", // translated 
  quotationRequestChatClickToSendSuggestion: "לחץ על שליחת הודעה זו", // translated 

  quotationRequestChatAddToFavorites: "חוסף למועדפים", // translated 
  quotationRequestChatRemoveFromFavorites: "הסר מהמועדפים", // translated 
  quotationRequestChatSubmitted: "נשלח", // translated 

  quotationRequestChatQuotationRequest: "בקשת הצעת מחיר: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{כּוֹתֶרֶת}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- סטטוס: {{status}}", // translated 

  quotationChatLoading: "טוען...", // translated 
  quotationChatSessionNotFound: "הפעלת צ'אט לא נמצאה להצעת מחיר זו", // translated 
  quotationChatMemberSessionNotFound: "הפעל את חבר לא נמצא לחשבון שלך", // translated 
  quotationChatUnableToConnect: "לא ניתן להתחבר לצ'אט", // translated 
  quotationChatConnecting: "מתחבר...", // translated 
  quotationChatTypeYourMessage: "הקלד את ההודעה שלך...", // translated 
  quotationChatConnected: "מחובר", // translated 
  quotationChatConnectingStatus: "מתחבר...", // translated 
  quotationChatDisconnected: "מנותק", // translated 
};


export default quotationChat;
